import BlackHolePage from './BlackHolePage';

export default BlackHolePage;
